import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.6441 10.0938C15.962 10.0938 15.4102 10.6461 15.4102 11.3276V12.4222C15.4102 13.1038 15.962 13.6561 16.6441 13.6561H20.998C21.4123 13.6561 21.748 13.9919 21.748 14.4061C21.748 14.8203 21.4123 15.1561 20.998 15.1561H16.6441C15.1331 15.1561 13.9102 13.9317 13.9102 12.4222V11.3276C13.9102 9.81808 15.1331 8.59375 16.6441 8.59375H20.998C21.4123 8.59375 21.748 8.92953 21.748 9.34375C21.748 9.75796 21.4123 10.0938 20.998 10.0938H16.6441Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2422 11.8203C16.2422 11.4061 16.578 11.0703 16.9922 11.0703H16.9951C17.4094 11.0703 17.7451 11.4061 17.7451 11.8203C17.7451 12.2345 17.4094 12.5703 16.9951 12.5703H16.9922C16.578 12.5703 16.2422 12.2345 16.2422 11.8203Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.9358 4.4375C5.6238 4.4375 3.75 6.3113 3.75 8.62331V15.3727C3.75 17.6847 5.6238 19.5585 7.9358 19.5585H16.0639C18.3759 19.5585 20.2497 17.6847 20.2497 15.3727V8.62331C20.2497 6.3113 18.3759 4.4375 16.0639 4.4375H7.9358ZM2.25 8.62331C2.25 5.48287 4.79537 2.9375 7.9358 2.9375H16.0639C19.2043 2.9375 21.7497 5.48287 21.7497 8.62331V15.3727C21.7497 18.5131 19.2043 21.0585 16.0639 21.0585H7.9358C4.79537 21.0585 2.25 18.5131 2.25 15.3727V8.62331Z",
			fill: "white"
		})
	]
});
export default SvgWalletProfile;
